import ScrollableTable from './ScrollableTable';

export default ScrollableTable;
